<template>
  <div class="sm-container bc">
    <div class="tc m-b-3">留下您的联系方式，专属顾问会尽快联系您</div>
    <el-form ref="form" :rules="rules" :model="formData" label-width="0" :inline="true" flex="main:justify">
      <el-form-item label="" prop="name">
        <el-input v-model="formData.name" placeholder="姓名" style="width:160px"></el-input>
      </el-form-item>
      <el-form-item label="" prop="phone">
        <el-input v-model="formData.phone" maxlength="11" placeholder="手机号码" style="width:160px"></el-input>
      </el-form-item>
      <el-form-item label="" prop="companyName">
        <el-input v-model="formData.companyName" placeholder="公司名称" style="width:160px"></el-input>
      </el-form-item>
      <el-form-item label="" prop="district" @click.native="getRegionTree">
        <el-cascader
          v-model="formData.district"
          :options="addressOptions"
          :props="{ value: 'name', label: 'name', children: 'child' }"
          placeholder="地址"
          style="width:160px"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <div class="tc">
      <el-button type="primary" :disabled="submitting" @click="doSubmitInternal">立即提交</el-button>
    </div>
  </div>
</template>
<script>
import contactFormMixin from '@/mixins/contactForm';

export default {
  name: '',
  props: {},
  mixins: [contactFormMixin],
  data() {
    return {};
  },
  computed: {},
  watch: {
    '$route.path'(nv, ov) {
      if (nv === ov) return;
      const { form } = this.$refs;
      form && form.clearValidate();
    },
  },
  methods: {
    doSubmitInternal() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.doSubmit()
          .then(() => {
            this.$message.success('提交成功');
            this.$emit('hide');
          })
          .catch(() => {
            this.$message.error('提交失败，请重试');
          });
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.el-form {
  .el-form-item {
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
